import React from 'react'
import { Link } from 'react-router-dom'
import lily_imagen_nueva from '../assets/images/psicologo/trauma_post.jpg'
import Navbar from '../components/navbar'
import Shape from '../components/shape'
import ShapeTwo from '../components/shape-two'
import Footer from '../components/footer'
import bg_ansiedad from '../assets/images/psicologo/bg_ansiedad.jpg'
import bg1 from '../assets/images/bg.jpg'

export default function PageTerm() {
  return (
    <>
     <Navbar/>
     
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${lily_imagen_nueva})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-white">Estrés postraumático</h4>
                          <p className="text-muted mb-0">Definición, síntomas y tratamientos</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="fw-bold text-white">Inicio</Link></li>
                          <li className="list-inline-item"><Link to="#" className="fw-bold text-white">Lo que tratamos</Link></li>
                          <li className="list-inline-item">
                              <span className="text-primary fw-bold">Estrés postraumático</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>
    <ShapeTwo/>

    <section className="section">
  <div className="container">
    <div className="row justify-content-center" style={{textAlign:'justify', padding:20}}>
      <div className="col-12">
        <h4>Introducción</h4>
        <p className="text-muted">
          El trastorno de estrés postraumático es una condición que aparece después de haber vivido o presenciado un evento traumático. Se caracteriza por revivir el evento en forma de recuerdos intrusivos o pesadillas, evitar recordatorios del trauma y mantener un estado constante de alerta.
        </p>
        <br />
        <h4 className='text-warning'>¿Qué es el trastorno de estrés postraumático?</h4>
        <p className="text-muted">
          Se asocia con una hiperactividad de la amígdala y una disminución del control de la corteza prefrontal sobre las respuestas emocionales. La neuromodulación busca restaurar el equilibrio entre estas áreas, disminuyendo la intensidad de las reacciones de miedo y facilitando la recuperación emocional.
        </p>
        <br />
        <h4>Síntomas comunes</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Físicos: tensión muscular constante, sobresaltos frecuentes, problemas de sueño.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Cognitivos: recuerdos intrusivos, dificultad para concentrarse, pensamientos negativos persistentes.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Conductuales: evitación de personas o lugares relacionados con el trauma, aislamiento social.
        </p>
        
        <br />
        <h4>Neuromodulación</h4>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Magnética Transcraneal (EMT): aplicada en corteza prefrontal para mejorar el control sobre respuestas emocionales.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Estimulación Transcraneal por Corriente Directa (tDCS): estimulación para disminuir la reactividad límbica.
        </p>
        <p className="text-muted">
          <i className="mdi mdi-chevron-double-right me-2"></i>
          Neurofeedback: entrenamiento para favorecer la relajación y la autorregulación emocional.
        </p>
      </div>
    </div>
  </div>
</section>

    <Footer/>
    </>
  )
}
